import { KNOB_DIRECTIONS } from 'crazyEditor/core/constants/editorConstants';
const props = {
  draggable: {x: true, y: true},
  hoverable: true,
  resizable: [
    KNOB_DIRECTIONS.MIDDLE_LEFT,
    KNOB_DIRECTIONS.MIDDLE_RIGHT,
  ],
  fullWidth: false,
  selectable: true,
  isTextElement: true,
  ckfinderEnabled: true,
  autoHeight: true,
  paddingSelectable: true,
  mobileFontSizeOnly: true,
  child: {
    autoHeight: false,
  },
};

Object.freeze(props);
export default props;
